<template>
    <div class="space-y-8">
        <!-- Form Errors -->
        <form-errors :store-form-errors="portalContentAndDesignStore.approvalFormErrors" />

        <!-- Approval Form -->
        <form @submit.prevent="onSubmit" class="space-y-6">
            <!-- Custom Fields -->
            <approval-custom-fields />

            <!-- Submit Button -->
            <editable-btn
                :prevent-double-click="5000"
                size="huge"
                class="w-full"
                button-type="submit"
                :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                :corners="portalContentAndDesignStore.getPublicPageButtonCorners"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_general_submit_approval"
            />
        </form>

    </div>
</template>

<script setup>
import {scrollToTop} from "../../../../../../helpers/common";
import { usePortalContentAndDesignStore } from "../../../../../../stores/partners/portalContentAndDesignStore";
import EditableBtn from "../../../../portal-editable-fields/EditableBtn.vue";
import FormErrors from "../../Errors/FormErrors.vue";
import ApprovalCustomFields from "./ApprovalCustomFields.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

// Add submission state to prevent double submissions
let isSubmitting = false;

const onSubmit = () => {
    // Prevent double submissions
    if (isSubmitting) {
        return;
    }
    
    isSubmitting = true;
    portalContentAndDesignStore.resetFormErrors('approval');
    
    // Transform the form data structure from cfields[1] format to nested cfields: {1: value} format
    const approvalData = portalContentAndDesignStore.approvalFormData || {};
    const cfields = {};
    
    // Extract cfields data from the flattened structure
    Object.keys(approvalData).forEach(key => {
        if (key.startsWith('cfields_phone_')) {
            const fieldId = key.replace('cfields_phone_', '');
            cfields[fieldId] = approvalData[key];
        } else if (key.startsWith('cfields[')) {
            // Handle nested checkbox structure like cfields[123][option1]
            const checkboxMatch = key.match(/cfields\[(\d+)\]\[(.+)\]/);
            if (checkboxMatch) {
                const fieldId = checkboxMatch[1];
                const optionKey = checkboxMatch[2];
                if (!cfields[fieldId]) {
                    cfields[fieldId] = {};
                }
                cfields[fieldId][optionKey] = approvalData[key];
            } else {
                // Handle simple structure like cfields[123]
                const simpleMatch = key.match(/cfields\[(\d+)\]/);
                if (simpleMatch) {
                    const fieldId = simpleMatch[1];
                    cfields[fieldId] = approvalData[key];
                }
            }
        }
    });
    
    const payload = {
        cfields: cfields,
        partner_id: portalContentAndDesignStore.approvalData.partner_id
    };
    
    // console.log('Submitting approval form with payload:', payload);
    
    axios.post(route('partners.inline_approval.submit'), payload)
        .then((response) => {
            if (+response.data.status === 1) {
                portalContentAndDesignStore.resetFormErrors('approval');
                window.location.href = response.data.redirect_url || route('partners.dashboard');
            } else {
                isSubmitting = false; // Reset submission state on error
                portalContentAndDesignStore.approvalFormErrors.responseError = response.data?.error;
                scrollToTop();
            }
        })
        .catch((error) => {
            isSubmitting = false; // Reset submission state on error
            if (error.response && error.response.status === 422) {
                // Handle validation errors from the controller
                portalContentAndDesignStore.approvalFormErrors.validationErrors = error.response?.data?.errors;
                if (error.response?.data?.status === 0) {
                    portalContentAndDesignStore.approvalFormErrors.responseError = 'Please correct the validation errors below.';
                }
                scrollToTop();
            } else {
                console.log('Approval submission error:', error.response);
                portalContentAndDesignStore.approvalFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
                scrollToTop();
            }
        });
};
</script>
